/*
 * mod='role'
 * author: nicy
 * time: 2019-02-21
 */

import { hasFeatureFlag } from '@/services';
import { smb_fetch, getAgpApiUrl } from '../../../fetch';
import fileapiUploader from '@/utils/fileapiUploaderByAgency';

const getAdvertiserUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);
  return result;
};

/**
 * 获取广点通广告主帐号列表
 * @return
 */
export const listGdt = (data, isShowError, options = {}) => {
  const url = getAdvertiserUrl('advertiser', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
      isCancel: true,
      timeout: 0,
      ...options,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
// 更新接口状态的接口
export const upDate = (data) => {
  const url = getAdvertiserUrl('advertiser', 'update_creativity_entry');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 获取广点通广告主帐号列表汇总信息
 * @return
 */
export const getAdvertiserListSummary = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_summary_list_by_get_list' : 'get_summary_list_by_get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
      isCancel: true,
      timeout: 0,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取广点通投放平台列表
 * @return
 */
export const AdvertisingList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_agency_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取投放平台列表 - new
 * @return
 */
export const getDeliveryReport = (data, isShowError = true) => {
  const url = getAdvertiserUrl('eservice/report', 'get_delivery_rpt');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, isShowError, false);
};

/**
 * 获取账户/投放列表汇总数据
 * @return
 */
export const getReportSummary = (data, isShowError = false) => {
  const url = getAdvertiserUrl('eservice/report', 'get_header_summary');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, isShowError, false);
};


/**
 * 小时报表列表
 */
export const getUserHourlyReportList = (data) => {
  const url = getAdvertiserUrl('report', 'get_user_hourly_report_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 下载广点通投放平台列表
 * @return
 */
export const DownloadList = (data) => {
  const url = getAdvertiserUrl('advertiser', 'download_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取广告的行业列表
 * @return
 */
export const getIndustryList = (data, isCache = true) => {
  const url = getAdvertiserUrl('advertiser', 'get_industry_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取广告行业的产品名称列表
 * @return
 */
export const getIndustryProductNameList = (data, isCache = true) => {
  const url = getAdvertiserUrl('advertiser', 'get_industry_product_name');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取客户行业资质体系结构
 * @return
 */
export const getIndustryInfo = (data) => {
  const url = getAdvertiserUrl('advertiser', 'get_industry_certifications_hierarchy_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取微信广告主帐号列表
 * @return
 */
export const getWechatList = (data) => {
  const url = getAdvertiserUrl('advertiser', 'get_wechat_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCancel: true,
      timeout: 0,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取微信广告主帐号列表汇总信息
 * @return
 */
export const getWechatAdvertiserListSummary = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_wechat_summary_list_by_get_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCancel: true,
      timeout: 0,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

// 预授权,取消预授权,同意取消授权微信广告主帐号
export const authWechatAdvertiser = (data) => {
  const url = getAdvertiserUrl('advertiser', 'auth_wechat_advertiser');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};
// 获取微信广告主帐号绑定记录列表
export const getWechatAuthLogList = (data) => {
  const url = getAdvertiserUrl('advertiser', 'get_wechat_auth_log_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
// 获取微信投放平台列表
export const getWechatAgencyRptList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_wechat_agency_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

// 获取微信投放平台昨日消耗列表
export const getWechatYesterdayCostList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_yesterday_cost_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      timeout: 0,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * @description 获取财务信息账户列表
 * @param data
 * @return {{then()}|Promise<never>|Promise<unknown>}
 */
export const getWechatAgencyAccountList = (data) => {
  const url = getAdvertiserUrl('wechat_account', 'get_wechat_account_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取员工列表
 * @author v_xmdjliu
 * @return
 */
export const getOperatorList = (data, options) => {
  const { needAgencyUid = true, ...rest } = options || {};
  if (!data.agency_uid) data.agency_uid = 0;
  const url = getAdvertiserUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      ...rest,
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );
  return smb_fetch(url, params, true, needAgencyUid);
};

/**
 * 获取下级员工
 * @return
 */
export const getSubordinateList = (data, isShowError = false) => {
  const url = getAdvertiserUrl('orbac_core_service/employee', 'list_subordinate');
  return smb_fetch(url, {
    method: 'POST',
    data,
    isCache: true,
  }, isShowError, false);
};

/**
 * 获取投放管理员列表
 * @return
 */
export const getAdvertiserList = (data) => {
  const url = getAdvertiserUrl('operator', 'get_advertiser_operator_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 更新账户投放管理人员
 * @return
 */
export const updateOperatorList = (data) => {
  const url = getAdvertiserUrl('operator', 'update_advertiser_master');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 设置广告主的运营人员
 * @return
 */
export const updateAdvertiserOperatorList = (data) => {
  const url = getAdvertiserUrl('operator', 'update_advertiser_operator_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 设置广告主的运营人员 - 新
 * @return
 */
export const updateAdvertiserOperators = (data) => {
  const url = getAdvertiserUrl('agms/v1/advertiser/operator', 'update');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 设置广告主的销售人员
 * @return
 */
export const updateSaleAdvertiserOperatorList = (data) => {
  const url = getAdvertiserUrl('operator', 'update_advertiser_sale_operator_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

export const downloadAdvertisingList = (data) => {
  const url = hasFeatureFlag('is_change_get_to_post_enable') ? '/agp/advertiser/get_new_list' : '/agp/advertiser/get_list';
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取区域列表
 * @return
 */
export const getAreaCodeList = (data, isCache = true) => {
  const { data: { agencyUid, ...paramData } = {} } = data || {};
  const url = getAdvertiserUrl('advertiser', 'get_area_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    {
      data: (paramData.uid && !agencyUid ? {
        ...paramData,
        _advertiser_id: paramData.uid,
        agency_uid: 0,
        bm_id: 0,
      } : paramData),
    },
  );
  return smb_fetch(url, params);
};

/**
 * 新增广点通广告主
 * @return
 */
export const addAdvertisingAccount = (data) => {
  const url = getAdvertiserUrl('advertiser', 'create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * copy方式创建合约子客（copy运营合约子客）
 * @return
 */
export const copyContractAdvertisingAccount = (data) => {
  const url = getAdvertiserUrl('advertiser', 'copy_contract');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 拉取广点通广告主详情-开户自动拉取（合约）
 * @return
 */
export const getReplicationAdvertiser = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_replication_advertiser');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 更新广点通广告主
 * @return
 */
export const updateAdvertisingAccount = (data) => {
  const url = getAdvertiserUrl('advertiser', 'update');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取广点通广告主详情
 * @return
 */
export const getAdvertisingDetail = (data, isShowError = true) => {
  const url = getAdvertiserUrl('advertiser', 'get');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取广点通广告主基础信息
 * @return
 */
export const getAdvertiserBasicInfo = (data, isShowError = true) => {
  const url = getAdvertiserUrl('advertiser', 'get_basic_info');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/*
 * 通过fileapi上传图片
 * @return
 */
export const uploadImgWithUidByFileapi = (params) => {
  const url = getAdvertiserUrl('advertiser', 'upload_img_for_user');
  const data = $.extend(
    true,
    {
      width: 0,
      height: 0,
    },
    params,
  );
  data.url = url;
  return fileapiUploader(data);
};
/*
 * 通过fileapi上传图片-资质图片加固
 * @return
 */
export const uploadImgWithUidSafe = (params) => {
  const url = getAdvertiserUrl('advertiser', 'upload_img');
  const data = $.extend(
    true,
    {
      width: 0,
      height: 0,
    },
    params,
  );
  data.url = url;
  return fileapiUploader(data);
};

/**
 * 获取投放信息
 * @return
 */
export const getAdvertisingInfo = (data) => {
  const portalUrl = data.data && data.data.url;
  const url = `${portalUrl}/registration/account/cps-info`;
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  delete params.data.url;
  return smb_fetch(url, params);
};

/**
 * 获取广点通广告主详情
 * @return
 */
export const getAdxUrl = (data) => {
  const url = getAdvertiserUrl('agency', 'get');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 更新日限额
 * @return
 */
export const updateDayBudget = (data) => {
  const url = getAdvertiserUrl('advertiser', 'update_day_budget');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 批量更新日限额
 * @return
 */
export const updateDayBudgetBatch = (data) => {
  const url = getAdvertiserUrl('eservice/account_man', 'batch_day_budget');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '修改日预算中，请稍后',
    data,
  }, false, false);
};

/**
 * 修改备注
 * @return
 */
export const updateRemark = (data) => {
  const url = getAdvertiserUrl('advertiser', 'update_remark');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 收藏
 * @return
 */
export const userCollectAdvertiser = (data) => {
  const url = getAdvertiserUrl('advertiser', 'collect');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 *  检测微信广告主信息
 * @return
 */
export const checkWechatInfo = (data) => {
  const url = getAdvertiserUrl('advertiser', 'check_wechat_advertiser_info');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 快速开户拉取信息
 * @return
 */
export const fastAddAcountGetDetails = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'check_copy');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 快速开户 开户
 * @return
 */
export const fastAddAcountAction = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'copy');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 快速开户 开户历史
 * @return
 */
export const fastAddAcountHistoryList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_copy_list' : 'get_copy_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'get',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 设置广告主的设计师
 * @return
 */
export const updateAdvertiserDesignerList = (data, isShowError) => {
  const url = getAdvertiserUrl('operator', 'update_advertiser_designer_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 设置广告主的观察者
 * @return
 */
export const updateAdvertiserObserverList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'update_advertiser_responded_user');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 获取对公打款流程
 * @return
 */
export const getAuthEnterprise = (data, isShowError) => {
  const url = getAdvertiserUrl('auth_enterprise', 'get');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 获取银行列表
 * @return
 */
export const getBankList = (data, isShowError) => {
  const url = getAdvertiserUrl('auth_enterprise', 'get_bank_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 获取列表托管数据
 * @return
 */
export const getTrusteeshipList = (data, isShowError) => {
  const url = getAdvertiserUrl('collocation', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 打款验证
 * @return
 */
export const check = (data, isShowError) => {
  const url = getAdvertiserUrl('auth_enterprise', 'check');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/** 关闭托管数据
 * /agp/collocation/delete
 * @return
 */
export const delDeposit = (data, isShowError) => {
  const url = getAdvertiserUrl('collocation', 'delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 *  检测行业是否是强控行业
 * @return
 */
export const checkIndustryInPkg = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'check_industry_in_pkg');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 申请打款
 * @return
 */
export const payAuth = (data, isShowError) => {
  const url = getAdvertiserUrl('auth_enterprise', 'pay');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 开启托管数据
 * /agp/collocation/create
 * @return
 */
export const createDeposit = (data, isShowError) => {
  const url = getAdvertiserUrl('collocation', 'create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取运营人员的一些字段
 * @return
 */
export const getRespondedList = (data, isShowError) => {
  const url = getAdvertiserUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_responded_list' : 'get_responded_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'get',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取广告主的任务数量
 * @return
 */
export const getAdvertiserTaskNumber = (data, isShowError) => {
  const url = getAdvertiserUrl('crm_task_service', 'agency_task/batch_get_advertiser_task');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取广告主列表
 * @return
 */
export const getAgencyAdvertiserList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取资质类型
 * @return
 */
export const getCertificationList = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_reg_certifications_hierarchy_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};


/**
 * 纸质版营业执照OCR
 */
export const checkLicenseOcr = (data, isShowError) => {
  const url = '/agp/agms/v1/ad/license/ocr';
  const params = $.extend(
    true,
    {
      method: 'POST',
      isCache: true,
    },
    {
      data,
      contentType: 'application/json',
    },
  );
  return smb_fetch(url, params, isShowError, false);
};

/**
 * 身份证OCR
 */
export const checkIDCardOcr = (data, isShowError) => {
  const url = '/agp/agms/v1/ad/id_card/ocr';
  const params = $.extend(
    true,
    {
      method: 'POST',
      isCache: true,
    },
    {
      data,
      contentType: 'application/json',
    },
  );
  return smb_fetch(url, params, isShowError, false);
};

/**
 * 获取搜狗流量新客牌照省份选项
 * @return
 */
export const getSgNewAdProvinceOption = (data) => {
  const url = getAgpApiUrl('adhome', 'new_advertiser/get_sougou_new_advertiser_province_manage_option');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    {
      data,
      contentType: 'application/json',
    },
  );

  return smb_fetch(url, params);
};

/**
 * 获取运营权变更记录
 * @return
 */
export const getOperationRightLog = (data, isShowError) => {
  const url = getAdvertiserUrl('advertiser', 'get_operation_right_log');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 批量设置运营权
 * @return
 */
export const batchChangeOperationMode = (data, isShowError) => {
  const url = getAdvertiserUrl('operation_mode', 'batch_change');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, isShowError);
};

/**
 * 获取运营权变更记录
 * @return
 */
export const getChangeRecords = (data, isShowError) => {
  const url = getAdvertiserUrl('operation_mode', 'get_change_records');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, isShowError);
};

/**
 * 获取当前用户运营权统计
 * @return
 */
export const getCurrentUserStats = (data, isShowError) => {
  const url = getAdvertiserUrl('operation_mode', 'get_current_user_stats');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, isShowError);
};

export default {
  getAdxUrl,
  listGdt,
  getAdvertiserListSummary,
  AdvertisingList,
  getDeliveryReport,
  getReportSummary,
  getIndustryList,
  getIndustryInfo,
  getWechatList,
  getWechatAdvertiserListSummary,
  authWechatAdvertiser,
  getWechatAuthLogList,
  getWechatAgencyRptList,
  getWechatYesterdayCostList,
  getOperatorList,
  updateOperatorList,
  downloadAdvertisingList,
  getAreaCodeList,
  addAdvertisingAccount,
  copyContractAdvertisingAccount,
  updateAdvertisingAccount,
  getAdvertisingDetail,
  uploadImgWithUidByFileapi,
  getAdvertisingInfo,
  getAdvertiserList,
  updateDayBudget,
  updateAdvertiserOperatorList,
  updateAdvertiserOperators,
  updateRemark,
  userCollectAdvertiser,
  checkWechatInfo,
  fastAddAcountGetDetails,
  fastAddAcountAction,
  fastAddAcountHistoryList,
  updateAdvertiserDesignerList,
  getAuthEnterprise,
  payAuth,
  check,
  getBankList,
  checkIndustryInPkg,
  getTrusteeshipList,
  createDeposit,
  delDeposit,
  getRespondedList,
  getWechatAgencyAccountList,
  getReplicationAdvertiser,
  upDate,
  getAdvertiserTaskNumber,
  getUserHourlyReportList,
  getAgencyAdvertiserList,
  updateAdvertiserObserverList,
  updateSaleAdvertiserOperatorList,
  getIndustryProductNameList,
  checkLicenseOcr,
  checkIDCardOcr,
  getSgNewAdProvinceOption,
  uploadImgWithUidSafe,
  getOperationRightLog,
  batchChangeOperationMode,
  getChangeRecords,
  getCurrentUserStats,
};
